import React, { Component } from "react";

const PublicWrapper = (Child) => { 
    return class extends Component {
        render() {
            return <Child />
        }
    }
}

export default PublicWrapper;